// Lista de resultados que flutua POR CIMA do pop-up (pedido do dono, 27/10/2026):
// dentro do pop-up ela esticava a rolagem e era preciso rolar o pop-up para ver
// os produtos. Vai para o <body> (portal) com posição fixa colada no campo de
// busca; abre para cima quando falta espaço embaixo e acompanha rolagem/redimensionamento.
import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

const ALTURA_MAX = 320;
const MARGEM = 8;

function medir(ancora) {
  const r = ancora.getBoundingClientRect();
  const embaixo = window.innerHeight - r.bottom - MARGEM;
  const emCima = r.top - MARGEM;
  const paraCima = embaixo < 200 && emCima > embaixo;
  return {
    left: r.left,
    width: r.width,
    maxHeight: Math.min(ALTURA_MAX, paraCima ? emCima : embaixo),
    ...(paraCima ? { bottom: window.innerHeight - r.top + 4 } : { top: r.bottom + 4 }),
  };
}

export default function ListaFlutuante({ ancoraRef, listaRef, children }) {
  const [pos, setPos] = useState(null);
  useLayoutEffect(() => {
    const atualizar = () => { if (ancoraRef.current) setPos(medir(ancoraRef.current)); };
    atualizar();
    // true = captura: pega também a rolagem do corpo do pop-up, não só a da página
    window.addEventListener("scroll", atualizar, true);
    window.addEventListener("resize", atualizar);
    return () => {
      window.removeEventListener("scroll", atualizar, true);
      window.removeEventListener("resize", atualizar);
    };
  }, [ancoraRef]);
  if (!pos) return null;
  return createPortal(
    <div ref={listaRef} data-e2e="promo-busca-lista" style={{ position: "fixed", ...pos }}
      className="z-[70] bg-card border rounded-lg shadow-2xl overflow-y-auto">
      {children}
    </div>,
    document.body,
  );
}
